import React from 'react';
import { UserCog, BarChart3, Shield, DollarSign, Zap, LayoutList } from 'lucide-react';
import { neuShadow, btnSm } from './crmShared';

export default function SopTab({ setTab }) {
  return (
    <div>
      <h3 style={{ fontSize: 15, fontWeight: 700, color: '#212529', margin: '0 0 16px' }}>ZignaGenix CRM — Patient Experience SOP</h3>

      {/* Purpose */}
      <div style={{ background: '#F8F9FA', borderRadius: 14, border: 'none', boxShadow: neuShadow, padding: 20, marginBottom: 16, borderLeft: '4px solid #2E8B98' }}>
        <h4 style={{ fontSize: 13, fontWeight: 700, color: '#212529', margin: '0 0 8px' }}>1. PURPOSE</h4>
        <div style={{ fontSize: 12, color: '#6C757D', lineHeight: 1.8 }}>
          Maximize: Speed-to-contact, Consult show rates, Close rates, Revenue per patient, Zero lead leakage — by forcing role clarity and ownership by stage.
        </div>
      </div>

      {/* Weekly Team Review */}
      <div style={{ background: '#F8F9FA', borderRadius: 14, border: 'none', boxShadow: neuShadow, padding: 20, marginBottom: 16, borderLeft: '4px solid #256F7A' }}>
        <h4 style={{ fontSize: 13, fontWeight: 700, color: '#212529', margin: '0 0 8px' }}>6. WEEKLY TEAM REVIEW (30 MIN MAX)</h4>
        <div style={{ fontSize: 12, color: '#6C757D', lineHeight: 1.8 }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>Agenda:</div>
          <div>1) Pipeline volume by stage &nbsp; 2) Scorecard review (no excuses) &nbsp; 3) Bottlenecks &nbsp; 4) Wins &nbsp; 5) Corrections for next week</div>
          <div style={{ marginTop: 8, fontWeight: 600, color: '#DC3545' }}>Rule: Data &gt; opinions — No defending numbers, fix them.</div>
        </div>
      </div>

      {/* Discipline Clause */}
      <div style={{ background: '#F8F9FA', borderRadius: 14, border: 'none', boxShadow: neuShadow, padding: 20, marginBottom: 16, borderLeft: '4px solid #DC3545' }}>
        <h4 style={{ fontSize: 13, fontWeight: 700, color: '#DC3545', margin: '0 0 8px' }}>7. DISCIPLINE CLAUSE</h4>
        <div style={{ fontSize: 12, color: '#6C757D', lineHeight: 1.8 }}>
          Failure to follow SOP, update CRM, or respect role boundaries = performance issue, not a misunderstanding.
        </div>
      </div>

      {/* Quick links */}
      <div style={{ background: '#F8F9FA', borderRadius: 14, border: 'none', boxShadow: neuShadow, padding: 20 }}>
        <h4 style={{ fontSize: 13, fontWeight: 700, color: '#212529', margin: '0 0 12px' }}>Quick Links</h4>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          <button onClick={() => setTab('users')} style={{ ...btnSm, color: '#2E8B98', borderColor: '#fce7f3' }}><UserCog size={13} /> Team Roles</button>
          <button onClick={() => setTab('scorecard')} style={{ ...btnSm, color: '#2E8B98', borderColor: '#dbeafe' }}><BarChart3 size={13} /> Scorecard</button>
          <button onClick={() => setTab('escalations')} style={{ ...btnSm, color: '#DC3545', borderColor: '#fecaca' }}><Shield size={13} /> Escalations</button>
          <button onClick={() => setTab('comp')} style={{ ...btnSm, color: '#62BB46', borderColor: '#d1fae5' }}><DollarSign size={13} /> Compensation</button>
          <button onClick={() => setTab('workflows')} style={{ ...btnSm, color: '#2E8B98', borderColor: '#e0e7ff' }}><Zap size={13} /> Workflows</button>
          <button onClick={() => setTab('pipeline')} style={{ ...btnSm, color: '#4FA038', borderColor: '#d1fae5' }}><LayoutList size={13} /> Pipeline</button>
        </div>
      </div>
    </div>
  );
}
